import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import { WebinarRegistrationInterface } from 'modules/funnels/funnel/types/webinar-registration-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useSWR from 'swr'

interface OptionsInterface {
  shouldFetch?: boolean
}

export function useWebinarRegistrationSettings(
  id?: number,
  options: OptionsInterface = { shouldFetch: true },
) {
  const { fetcher } = useFetch<RequestMethodsEnum.get, WebinarRegistrationInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: webinarRegistrationSettings, mutate: mutateWebinarRegistrationSettings } = useSWR(
    () => {
      if (!id) return
      if (!options.shouldFetch) return
      return `${FUNNELS_API}/steps/${id}/webinar-registration`
    },
    fetcher,
  )

  return { webinarRegistrationSettings, mutateWebinarRegistrationSettings }
}
